import {ActionTree, MutationTree,GetterTree} from 'vuex'
import {RootState} from '@/store/types'
import {SERVER_HOST_QR} from '@/config';
import VueI18n from '../../helpers/i18n';
import store from '@/store'

import axios from 'axios';
import {filterQuery} from "@/helpers/filter";

export interface State {
  products: any[],
  loading: boolean,
  thematics: any[]
}

const defaultState: State = {
  products: [],
  loading: false,
  thematics: [],
};

const getters:GetterTree<State, RootState> = {
  products: (state: State) => state.products,
  loading: (state: State) => state.loading,
  thematics: (state: State) => state.thematics,
}

const mutations: MutationTree<State> = {
  setNewProduct(state: State, payload: any[]) {
    state.products.push(payload)
  },
  setProducts(state: State, payload: any[]) {
    state.products = payload
  },
  setThematics(state: State, payload: any[]) {
    state.thematics = payload
  },
  setDeleteProduct(state: State, payload: any[]) {
    state.products = state.products.filter((product:any) => {
      return product.id != payload
    })
  },
  setEditProduct(state: State, payload: any) {
    state.products = state.products.map((product:any) => {
      if (product.id == payload.id) {
        return payload
      } else {
        return product
      }
    })
  },
  setLoadStatus(state: State, payload: boolean) {
    state.loading = payload
  },
}

const actions: ActionTree<State, RootState> = {
  async loadProductsFromServer({commit, state}, payload:any) {
    commit('setLoadStatus', true)

    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'show/company/products')
      const thematics = await axios.get(SERVER_HOST_QR + 'show/' + payload + '/thematic')
      if (data.error) {
        throw (data.error)
      }
      commit('setProducts', data.data)
      commit('setThematics', thematics.data.data)
      commit('setLoadStatus', false)

    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }
  },
  async saveNewProduct({commit, state}, payload:any) {
    commit('setLoadStatus', true)

    try {
      const {data} = await axios.post(SERVER_HOST_QR + 'show/company/products', payload)
      if (data.error) {
        throw (data.error)
      }
      commit('setNewProduct', data.data)
      commit('setLoadStatus', false)

    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }
  },
  async deleteProduct({commit, state}, payload:any) {
    commit('setLoadStatus', true)

    try {
      const {data} = await axios.delete(SERVER_HOST_QR + 'show/company/products/' + payload)
      if (data.error) {
        throw (data.error)
      }
      console.log(data)
      commit('setDeleteProduct', payload)
      commit('setLoadStatus', false)

    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }
  },
  async editProduct({commit, state}, payload:any) {
    commit('setLoadStatus', true)

    try {
      const {data} = await axios.patch(SERVER_HOST_QR + 'show/company/products/' + payload.id, payload.params)
      if (data.error) {
        throw (data.error)
      }
      console.log(data)
      commit('setEditProduct', data.data)
      commit('setLoadStatus', false)

    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
